import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { dateFormat, externalCreditStatusName, externalCreditStatusColorMap, currencyName } from 'enums';
import { detailsBtn, statusText } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var externalCreditListColumns = [{
  name: 'ID',
  render: function render(externalCredit) {
    return ___EmotionJSX(Link, {
      to: {
        pathname: "external-credit/details/".concat(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.id),
        state: {
          externalCredit: externalCredit
        }
      }
    }, externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.id);
  }
}, {
  name: '№',
  value: 'number'
}, {
  name: 'Кредитополучател',
  value: 'borrower_name'
}, {
  name: 'Сума',
  render: function render(_ref) {
    var _currencyName$currenc;

    var amount = _ref.amount,
        currency = _ref.currency;
    return ___EmotionJSX("span", null, amount ? "".concat(amount, " ").concat((_currencyName$currenc = currencyName[currency]) !== null && _currencyName$currenc !== void 0 ? _currencyName$currenc : currency) : '--');
  }
}, {
  name: 'Платено',
  render: function render(_ref2) {
    var _currencyName$currenc2;

    var payed = _ref2.payed,
        currency = _ref2.currency;
    return ___EmotionJSX("span", null, payed ? "".concat(payed, " ").concat((_currencyName$currenc2 = currencyName[currency]) !== null && _currencyName$currenc2 !== void 0 ? _currencyName$currenc2 : currency) : '--');
  }
}, {
  name: 'Статус',
  render: function render(_ref3) {
    var _externalCreditStatus;

    var status = _ref3.status;
    return ___EmotionJSX("span", {
      css: statusText(externalCreditStatusColorMap[status])
    }, (_externalCreditStatus = externalCreditStatusName[status]) !== null && _externalCreditStatus !== void 0 ? _externalCreditStatus : '--');
  }
}, {
  name: 'Дата',
  value: 'date',
  dateTimeFormat: dateFormat
}, {
  name: '',
  render: function render(externalCredit) {
    return ___EmotionJSX(TableActions, {
      mainAction: {
        linkTo: {
          pathname: "/external-credit/details/".concat(externalCredit === null || externalCredit === void 0 ? void 0 : externalCredit.id),
          state: {
            externalCredit: externalCredit
          }
        },
        leftIcon: {
          iconName: 'la la-info',
          size: 20
        },
        css: detailsBtn
      }
    });
  },
  width: '50px'
}].filter(Boolean);